import styled from "@emotion/styled"

export const ContainerUI = styled("div")`
  max-width: 640px;
  margin: auto;
  padding: 0 20px;
`

export default ContainerUI
